"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    rpc: {},
    types: {
        AcalaStakingLedge: {
            bonded: 'Compact<Balance>',
            unlocking: 'Vec<UnlockChunk>'
        },
        AcalaUnlockChunk: {
            value: 'Compact<Balance>',
            era: 'Compact<EraIndex>'
        }
    }
};
